import { gql } from "@apollo/client";

export const GetSpacesQuery = gql`
query GetSpaceDetails($name: String = "") {
  spaces(where: {name: {_ilike: $name}}) {
    id
    details
  }
}
`